import React from 'react'
import { Box, Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import { formatCurrency, formatPercent } from '../utils'
import StatCard from './StatCard'

interface KeyStatsPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const KeyStatsPanel: React.FC<KeyStatsPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => {
  return (
    <Box>
      <Heading as="h3" mb={4} size="md">Key Statistics</Heading>
      <Grid gap={4} templateColumns={`repeat(${gridTemplateColumns || 2}, 1fr)`}>
        <StatCard
          bg={statCardBg}
          label="P/E Ratio"
          value={data.peRatio.toFixed(2)}
        />
        <StatCard
          bg={statCardBg}
          label="EPS"
          value={data.keyStats.eps.toFixed(2)}
        />
        <StatCard
          bg={statCardBg}
          label="PEG Ratio"
          value={data.keyStats.pegRatio.toFixed(2)}
        />
        <StatCard
          bg={statCardBg}
          label="Price to Book"
          value={data.keyStats.priceToBook.toFixed(2)}
        />
        <StatCard
          arrowType={data.keyStats.profitMargin >= 0 ? 'increase' : 'decrease'}
          bg={statCardBg}
          label="Profit Margin"
          value={formatPercent(data.keyStats.profitMargin * 100)}
        />
        <StatCard
          bg={statCardBg}
          label="Enterprise Value"
          value={formatCurrency(data.keyStats.enterpriseValue)}
        />
        <StatCard
          bg={statCardBg}
          label="EV/Revenue"
          value={data.keyStats.enterpriseValueToRevenue.toFixed(2)}
        />
        <StatCard
          bg={statCardBg}
          label="Debt to Equity"
          value={data.keyStats.debtToEquity.toFixed(2)}
        />
        <StatCard
          bg={statCardBg}
          label="Dividend Yield"
          value={formatPercent(data.dividendYield * 100)}
        />
        <StatCard
          bg={statCardBg}
          label="Dividend Rate"
          value={data.dividendRate.toFixed(2)}
        />
      </Grid>
    </Box>
  )
}

export default KeyStatsPanel
